import { useContext, useState } from 'react';
import Spinner from '../../../../reusable/spinner/spinner.component';
import Button from '../../../../reusable/button/button.component';
import { ToastContext } from '../../../../../contexts/toast.context';
import Client from '../../../../../tools/client';

import {
  MainContainer,
  InputContainer,
  UpdateLabel,
  UpdateInput,
  ButtonContainer,
  ButtonRowContainer
} from './update-shipping-type.styles';

const client = new Client();

const UpdateShippingType = ({ typeData, getType, setShowUpdate }) => {
  const [name, setName] = useState(typeData.name);
  const [speedDays, setSpeedDays] = useState(typeData.speedDays ?? '');
  const [loading, setLoading] = useState(false);

  const { errorToast, successToast } = useContext(ToastContext);

  const updateType = async () => {
    setLoading(true);

    const payload = {
      name,
      speedDays: speedDays !== '' ? parseInt(speedDays, 10) : null
    };

    const res = await client.updateShippingType(typeData.id, payload);

    if (res.status === 400 || res.error) {
      setLoading(false);
      errorToast(res.message || 'Failed to update shipping type');
      return;
    }

    successToast('Shipping type updated');
    await getType();
    setLoading(false);
    setShowUpdate(false);
  };

  return (
    <MainContainer>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <InputContainer>
            <UpdateLabel>Name:</UpdateLabel>
            <UpdateInput value={name} onChange={(e) => setName(e.target.value)} />
          </InputContainer>

          <InputContainer>
            <UpdateLabel>Speed (days):</UpdateLabel>
            <UpdateInput
              type="number"
              value={speedDays}
              onChange={(e) => setSpeedDays(e.target.value)}
            />
          </InputContainer>

          <ButtonContainer>
            <ButtonRowContainer>
              <Button onClick={() => setShowUpdate(false)}>Cancel</Button>
              <Button onClick={updateType}>Update</Button>
            </ButtonRowContainer>
          </ButtonContainer>
        </>
      )}
    </MainContainer>
  );
};

export default UpdateShippingType;